import React, { useState, useEffect } from "react";
import { overlayButtonStyle } from "../../../utils/layout";
import Button from "react-bootstrap/Button";
import { useLocation, useNavigate } from "react-router-dom";
import XframeContainer from "../xframedItems/XframeContainer";
import { urls } from "../../../utils/urls";
import { makeGetRequest } from "../../../utils/api";

function MeditationXframe() {
  const [xframe, setXframe] = useState("");
  const [name, setName] = useState("");

  const navigate = useNavigate();
  const location = useLocation();

  const isLandscape = () =>
      window.matchMedia("(orientation:landscape)").matches,
    [orientation, setOrientation] = useState(
      isLandscape() ? "landscape" : "portrait"
    ),
    onWindowResize = () => {
      clearTimeout(window.resizeLag);
      window.resizeLag = setTimeout(() => {
        delete window.resizeLag;
        setOrientation(isLandscape() ? "landscape" : "portrait");
      }, 200);
    };

  const handleData = async () => {
    const response = await makeGetRequest(
      urls.resources + "?active=True",
      "",
      true
    );
    const meditiationData = response.data.filter((item) => {
      return item.type === 6;
    });
    setXframe(meditiationData[0].url);
    setName(meditiationData[0].name);
  };

  const backToHome = () => {
    navigate("/cog-wheel");
  };

  useEffect(
    () => (
      onWindowResize(),
      window.addEventListener("resize", onWindowResize),
      () => window.removeEventListener("resize", onWindowResize)
    ),
    []
  );

  useEffect(() => {
    handleData();
  }, []);

  return (
    <>
      {xframe && (
        <>
          <Button
            style={overlayButtonStyle(0)}
            onClick={() => backToHome()}
          >
            Back to Home
          </Button>
          <XframeContainer url={xframe} name={name} orientation={orientation} />
        </>
      )}
      {!xframe && (
        <div style={{ marginTop: "100px" }}>
          No meeting data found. Please contact your administration.{" "}
        </div>
      )}
    </>
  );
}

export default MeditationXframe;
